<ng-container *ngIf="activeStep === stepIndex">
    <div class="form-group">
        <div class="auth">
            <ng-container *ngFor="let card of cards index as i">
                <div class="content-space-between" [class.selected]="selectedCard.index === i">
                    <div class="content">
                        <div class="content-left card-img">
                            <img
                                ngSrc="{{card.brandLogoPath}}"
                                class="card-icon"
                                width="32"
                                height="32"
                                alt="payment card icon for {{card.brand}}">
                        </div>
                        <div class="content-left">
                            <strong>{{ card.brand | titlecase }}</strong>
                        </div>
                        <div class="content-left">
                            <span class="card-ending">
                                {{ 'billing_card_ending' | myLbTranslate }} {{ card.last4 }}
                            </span>
                        </div>
                        <div class="content-left">
                            <span>{{ card.expiry }}</span>
                        </div>
                    </div>
                    <input
                        type="radio"
                        id="{{card.id}}"
                        tabindex="0"
                        name="{{card.id}}"
                        [checked]="card.id === selectedCard.id"
                        (click)="setSelectedCard(card, i)">
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="activeStep > stepIndex">
    <div class="set-content">
        <div class="content-left">
            <div class="card-title">
                <strong>{{ 'billing_card_selected' | myLbTranslate }}:</strong>
            </div>
            <img
                ngSrc="{{selectedCard.brandLogoPath}}"
                class="card-icon"
                width="32"
                height="32"
                alt="payment card icon for {{selectedCard.brand}}">
            <span> {{ selectedCard.last4 }}</span>&nbsp;
            <span> {{ selectedCard.expiry }}</span>
        </div>
        <span>
            <button id="select-payment_edit-method" class="button-as-link quinary right-arrow" (click)="setStep()">
                {{ 'edit' | myLbTranslate }}
            </button>
        </span>
    </div>
</ng-container>


